// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header___wMr1s","p":"p___3xDq-","backHome":"backHome___1RHd5","li":"li___1-Dos","link":"link___2LNy_"};


//////////////////
// WEBPACK FOOTER
// ./app/js/components/Header/style.scss
// module id = 117
// module chunks = 0